export default __webpack_public_path__ + "static/fire_extinguisher_w.d6e156769092db27a6145e1afbc952b0.svg";